import { getEnabledChoices } from "./getEnabledChoices";
import { getSettings } from "./getSettings";
import { getSettingsComplete } from "./getSettingsComplete";
import { getSettingsCompleteAsDictionary } from "./getSettingsCompleteAsDictionary";

export const settingsAPI = {
  getEnabledChoices,
  getSettings,
  getSettingsComplete,
  getSettingsCompleteAsDictionary,
};
export type SettingsAPI = typeof settingsAPI;
